import { Getters } from 'vuex-smart-module';
import ReportsMutualsState from './state';

export default class ReportsMutualsGetters extends Getters<ReportsMutualsState> {}
